import { render, staticRenderFns } from "./disclaimers-section.vue?vue&type=template&id=0f449203&scoped=true"
import script from "./disclaimers-section.vue?vue&type=script&lang=ts"
export * from "./disclaimers-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f449203",
  null
  
)

export default component.exports